import React, { useState } from 'react';

import { useTranslation } from 'react-i18next';

import { getUser } from 'redux/authentication/auth.slice';

import Input from '../../../../../../components/Input/Text/Input';
import AllStudents from '../students/AllStudents';
import { createGroupsForTeacherByLesson } from '../../../../../../redux/liveClass/teacherCreateGroups.slice';
import { useAppDispatch, useAppSelector } from '../../../../../../redux/hooks';
import { liveClassStudentsState } from '../../../../../../redux/liveClass/students.slices';
import { getHeaderActiveClass } from '../../../../../../redux/header/selectors';

const CreateGroupModal: React.FC = () => {
  const { t } = useTranslation('live_classes');
  const dispatch = useAppDispatch();
  const [name, setName] = useState('');
  const { selectedStudents } = useAppSelector(liveClassStudentsState);
  const activeSubject = useAppSelector(getHeaderActiveClass);
  const user = useAppSelector(getUser);

  return (
    <div
      className="children"
      style={{
        minWidth: '60vw',
      }}
    >
      <label className={'input-and-icons'}>
        <h4>Group name</h4>
        <Input
          type={'text'}
          placeholder={t('Enter a group name')}
          onChange={e => {
            setName(e);
          }}
        />
      </label>
      <AllStudents />
      <div className={'flex justify-center mt-6'}>
        <button
          className="btn green rounded-full"
          onClick={() =>
            dispatch(
              createGroupsForTeacherByLesson({
                object: {
                  name,
                  students: {
                    data: selectedStudents.map(obj => {
                      return {
                        user_id: obj,
                      };
                    }),
                  },
                  lesson_id: activeSubject.id,
                  teacher_id: user.id,
                },
              })
            )
          }
        >
          Add to group
        </button>
      </div>
    </div>
  );
};

export default CreateGroupModal;
